import { byUkrainianAlphabet } from './alphabet';
import districts from './data/districts.json';
import { OBLASTS } from './oblasts';

// Районы по областям: 136 районов Украины (с 2020 года) и районы Киева и Севастополя (у них вместо районов
// области районы города), по-украински, с словом «район». Файл data/districts.json собирается скриптом
// scripts/build-settlements.py из официального кодификатора КАТОТТГ вместе со списком населённых пунктов
// (data/settlements.json), поэтому название района здесь и там одно и то же. Если районы переименуют,
// скрипт запускается заново с новым кодификатором.

// Область с опечаткой в названии осталась бы без районов, и никто бы не заметил: ломаем сразу.
Object.keys(districts).forEach((oblast) => {
  if (!OBLASTS.includes(oblast)) throw new Error(`Районы записаны для области, которой нет в списке: ${oblast}`);
});

export const DISTRICTS = OBLASTS.reduce((all, oblast) => {
  all[oblast] = [...(districts[oblast] || [])].sort(byUkrainianAlphabet);
  return all;
}, {});

const KNOWN = new Set(Object.values(DISTRICTS).flat());

// Районы выбранной области. Без области (или со старым значением, которого нет в списке) пусто.
export const districtsOf = (oblast) => DISTRICTS[oblast] || [];

// Название из справочника, а не вписанное вручную.
export const isKnownDistrict = (name) => KNOWN.has(name);

// Район после смены области: район из справочника, который к новой области не относится,
// сбрасывается; вписанное вручную название остаётся.
export const regionAfterOblastChange = (region, oblast) =>
  isKnownDistrict(region) && !districtsOf(oblast).includes(region) ? '' : region;
